const TokenKey = 'Admin-Token'


export default {
  getToken() {
    return localStorage.getItem(TokenKey)
  },
  setToken(token) {
    return localStorage.setItem(TokenKey, token)
  },
  removeToken() {
    return localStorage.removeItem(TokenKey)
  },
  getTokenFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams,2323232);
    return urlParams.get('token') || '';
  },



}
